export default __webpack_public_path__ + "static/couple-766b9364b004a2a3f5ea42e6058cb55e.png";